import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const ARN = ({
  awsARN = {
    value: ""
  },
  awsExternalId = {
    value: ""
  },
  onChange
}) => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "awsAssumeRoleARN",
      type: "text",
      value: awsARN.value,
      onChange,
      label: t("aws_arn.assume_role_label"),
      help: t("aws_arn.assume_role_help"),
      placeholder: t("aws_arn.assume_role_placeholder"),
      maxLength: 2048
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "awsExternalId",
      type: "text",
      name: "awsExternalId",
      value: awsExternalId.value,
      onChange,
      label: t("aws_arn.external_id_label"),
      help: t("aws_arn.external_id_help")
    }
  ));
};
export default ARN;
